// extracted by mini-css-extract-plugin
export default {"react":"React_react__BbyMX","divs":"React_divs__eKzLo"};